import React from 'react';
import { Star, MessageCircle } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const GoogleReviews = () => {
  return (
    <div className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Customer <span className="text-red-600">Reviews</span>
          </h2>
          <p className="text-gray-600">Your feedback helps us serve you better</p>
        </div>

        {/* Empty State for Reviews */}
        <Card className="max-w-4xl mx-auto border-2 border-dashed border-gray-300">
          <CardContent className="p-12 text-center">
            <div className="mb-6">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-red-100 rounded-full mb-4">
                <MessageCircle className="w-10 h-10 text-red-600" />
              </div>
              <h3 className="text-2xl font-bold mb-3">Be the First to Review Us!</h3>
              <p className="text-gray-600 max-w-md mx-auto mb-6">
                We'd love to hear about your experience with Taylormade Professional Cleaning. 
                Your feedback helps us improve and helps others make informed decisions.
              </p>
            </div>
            
            <div className="flex justify-center mb-6">
              {[...Array(5)].map((_, i) => (
                <Star key={`empty-star-${i}`} className="w-8 h-8 text-gray-300" />
              ))}
            </div>

            <a 
              href="https://www.google.com/maps" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center px-8 py-4 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-lg transition-colors text-lg shadow-lg hover:shadow-xl"
            >
              <Star className="w-5 h-5 mr-2" />
              Leave a Google Review
            </a>

            <p className="text-sm text-gray-500 mt-6">
              Once you have a Google Business Profile, reviews will appear here automatically
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default GoogleReviews;
